<app-navbar title="Potwierdzenia">
	<a class="btn btn-warning me-4" routerLink="/timetable/{{ timetableId }}">
		<i class="fas fa-random"></i> Rozkład
	</a>
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<table class="table table-striped table-hover table-bordered">
	<thead>
		<tr>
			<th>Status</th>
			<th>BC</th>
			<th>Nazwisko</th>
			<th>Imie</th>
			<th>TEL</th>
			<th>Miasto wyjazdu</th>
			<th>Godzina wyjazdu</th>
			<th>Miejsce wyjazdu</th>
			<th>PAK</th>
			<th>Produkt</th>
			<th></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of data">
			<td>{{ row.status }}</td>
			<td>{{ row.businessCaseNumber }}</td>
			<td>{{ row.lastName }}</td>
			<td>{{ row.firstName }}</td>
			<td>{{ row.phone }}</td>
			<td>{{ row.originCity }}</td>
			<td>{{ row.time }}</td>
			<td>{{ row.detail }}</td>
			<td>{{ row.services }}</td>
			<td>{{ row.accommodation }}</td>
			<td>
				<button type="button" class="btn btn-primary" *ngIf="row.saveStatus === '0'" (click)="confirm(row)">
					Potwierdź
				</button>
				<button type="button" class="btn btn-success" *ngIf="row.saveStatus === '1'" (click)="unconfirm(row)">
					<i class="fas fa-check"></i> Potwierdzone
				</button>
				<button type="button" class="btn btn-danger" *ngIf="row.saveStatus === '2'">
					<i class="fas fa-spinner fa-pulse"></i> Zapisywanie
				</button>
			</td>
		</tr>
	</tbody>
</table>
